import agent from './agent'

export const Comment = {
	getComment: async (lineId) => {
		return new Promise((resolve, reject) => {
			return agent.Request.get(`/firestoreForm2/comment`)
				.then(response => resolve(response))
		})
	},
}